/* SiteCodeRenderer.js */

"use strict";

//const _ = require("lodash");

class SiteCodeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("sitecode-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("SiteCode", (this._onSiteCode = this._onSiteCode.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("SiteCode");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setSiteCode(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onSiteCode(newVal) {
        this._setSiteCode(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setSiteCode(newVal) {
        // /frontend/topology/<siteId>?deviceId=<deviceId>
        if (newVal && newVal.siteCodeName) {
            if (this._model._hasTopologyLicense && this._model._hasTopologyAccess) {
                this._rootElem.innerHTML = `
                    <span class="sitecode-text">${newVal.siteCodeName}</span>
                    <a class="sitecode-link g-icon g-icon-exit-from-the-app" href="/frontend/topology/${newVal.siteId}?deviceId=${newVal.id}"></a>
                `;
            } else {
                this._rootElem.innerHTML = `
                    <span class="sitecode-text">${newVal.siteCodeName}</span>
                `;
            }
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = SiteCodeRenderer;
